import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class AdminScenarioSetupService {

  constructor(private http: HttpClient) { }

  /**
   * Save scenario setup
   * @param baseUrl - Base URL for API
   * @param scenarioEntity - Scenario entity data
   * @param globalService - Global service parameters
   * @param filterParams - Filter parameters
   * @param rowData - Row data
   * @returns Observable with save response
   */
  saveScenarioSetup(
    baseUrl: string,
    scenarioEntity: any,
    globalService: any = {},
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Build clob_settings
    const jsonSettings = {
      tax_year: filterParams.tax_year
    };

    // Clone and merge scenario entity with filter params
    let jsonObj = _.cloneDeep(scenarioEntity);
    jsonObj = _.merge({}, jsonObj, filterParams);

    // Build params from globalService and filterParams
    // Note: globalService IS already the globalParams object
    let params = _.merge({}, globalService || {}, filterParams);

    // Add clob_data and clob_settings
    params = _.extend({
      clob_data: JSON.stringify(jsonObj)
    }, params);

    params = _.extend({
      clob_settings: JSON.stringify(jsonSettings)
    }, params);

    // Add checkLockedbj parameter
    const checkLockedbj = [{
      scenario_key: filterParams.scenario || params.scenario
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Add scenarioCode parameter (with fallbacks matching AngularJS pattern)
    params.scenarioCode = filterParams.scenarioCode || 
                          filterParams.scenario_code || 
                          params.scenarioCode || 
                          params.scenario_code || 
                          "RAF";

    // Add required parameters
    params.is_issue_key_enabled = 'N';

    // Build URL
    const url = `${baseUrl}/saveJsonObject?action_code=f5r4g2`;

    // Convert params to URLSearchParams for application/x-www-form-urlencoded
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    // Set headers for form-urlencoded
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}

